import { render, staticRenderFns } from "./Addlease.vue?vue&type=template&id=673ffce4&scoped=true"
import script from "./Addlease.vue?vue&type=script&lang=js"
export * from "./Addlease.vue?vue&type=script&lang=js"
import style0 from "./Addlease.vue?vue&type=style&index=0&id=673ffce4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673ffce4",
  null
  
)

export default component.exports